import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { areRadioButtonStatesEqual, RADIO_BUTTON_INITIAL_STATE } from './cost-to-build-client-ui-radio-button.state';
import type { RadioButtonState } from './cost-to-build-client-ui-radio-button.types';

export const RadioButtonStore = signalStore(
    withState(RADIO_BUTTON_INITIAL_STATE),
    withComputed((store) => ({
        isDisabled: computed(() => store.disabled()),
        resolvedAriaLabel: computed(() => store.ariaLabel() || store.label()),
        state: computed<RadioButtonState>(() => ({
            ariaLabel: store.ariaLabel(),
            checked: store.checked(),
            disabled: store.disabled(),
            id: store.id(),
            label: store.label(),
            name: store.name(),
            value: store.value(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<RadioButtonState>) => {
            const nextState: RadioButtonState = {
                ...store.state(),
                ...patch,
            };

            if (areRadioButtonStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return { setState };
    })
);
